import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

import * as types from '../actionTypes';

/** @typedef {import('utils/ReduxUtils').EntitySlice<import('../types').StoredWhiteListedPlate>} WhitelistDataEntity */

/** @type {import('utils/ReduxUtils').EntityAdapter<import('../types').StoredWhiteListedPlate>} */
export const whitelistAdapter = createEntityAdapter({ selectId: ({ id }) => id });

/**
 * @param {WhitelistDataEntity} state
 * @param {{ payload: { content: import('../types').StoredWhiteListedPlate[] } }} action
 * @returns {WhitelistDataEntity}
 */
const updateManyFromPage = (state, { payload: { content } }) => whitelistAdapter.setAll(state, content || []);

export default createReducer(whitelistAdapter.getInitialState(), {
  [types.FETCH_WHITELIST_SUCCESS]: updateManyFromPage,
  [LOCATION_CHANGE]: () => whitelistAdapter.getInitialState(),
});
